import { useMemo, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import IconStar from "../../assets/icons/icon-star.svg";
import useLocationReviews from "../../hooks/useLocationReviews";
import CarouselButtons from "../carousel-buttons/carousel-buttons";

import styles from "./location-reviews.module.scss";

const StarRating = ({ rating }) => {
  return Array(parseInt(Math.round(rating))).fill(<IconStar width={14} />);
};

const ReviewItem = ({ name, content, rating, date }) => {
  return (
    <div className={styles.ReviewItem}>
      <div className={styles.ReviewHeader}>
        <div className={styles.ReviewAuthor}>{name}</div>
        <div className={styles.Stars}>
          <StarRating rating={rating} />
        </div>
      </div>
      <div className={styles.ReviewContent}>
        <p>{content}</p>

        <p className={styles.Date}>{new Date(date).toDateString()}</p>
        {/* <p className={styles.Date}>{format(date, "MMMM d, yyyy")}</p> */}
      </div>
    </div>
  );
};

const LocationReviews = ({ location }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const { loading, error, reviews } = useLocationReviews(
    location.googlePlacesId
  );

  const filteredReviews = useMemo(() => {
    if (reviews) {
      return reviews?.reviews?.filter((review) => review.rating >= 3);
    }
    return [];
  }, [reviews]);

  if (loading) return null;

  if (error) return null;

  if (!reviews) return null;

  return (
    <div className={styles.LocationReviews}>
      <div className={styles.Header}>
        <div className={styles.Score}>
          <div className={styles.ScoreNumber}>{reviews.rating}</div>
          <div>
            <IconStar width={18} />
          </div>

          <div>
            <h3>Reviews</h3>
          </div>
        </div>
        <div className={styles.Link}>
          <a href={reviews.url} rel="noreferrer" target="_blank">
            {reviews.user_ratings_total} Google Reviews
          </a>
        </div>
      </div>
      <div className={styles.DesktopReviews}>
        {filteredReviews
          .filter((review) => review.rating >= 3)
          .map((review) => {
            return (
              <ReviewItem
                key={review.author_url}
                name={review.author_name}
                rating={review.rating}
                content={review.text}
                date={review.time * 1000}
              />
            );
          })}
      </div>
      <div className={styles.MobileReviews}>
        <Carousel
          showArrows={false}
          showStatus={false}
          infiniteLoop={false}
          showIndicators={false}
          autoPlay={false}
          selectedItem={currentSlide}
          swipeScrollTolerance={20}
          preventMovementUntilSwipeScrollTolerance
          onChange={(index) => setCurrentSlide(index)}
        >
          {filteredReviews
            .filter((review) => review.rating >= 3)
            .map((review) => {
              return (
                <ReviewItem
                  key={review.author_url}
                  name={review.author_name}
                  rating={review.rating}
                  content={review.text}
                  date={review.time * 1000}
                />
              );
            })}
        </Carousel>
        <CarouselButtons
          slides={[1, 2, 3].map((post, index) => ({
            active: index === currentSlide
          }))}
          onChange={(index) => setCurrentSlide(index)}
        />
      </div>
    </div>
  );
};

export default LocationReviews;
